import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'src/lib/i18n-react'
import { Flex, Button, Box, Image } from '@chatterbug/aaron'
import LiveDate from 'src/components/LiveDate'
import { getTimezone } from 'src/config/globals'

import routes from 'src/lib/rails-routes/rails-routes'
import UpcomingLessonIcon from 'src/ui/UpcomingLessonIcon/UpcomingLessonIcon'
import DateUtil from 'src/lib/date-util'

const TimeDetails = ({ startTime }) => {
  return (
    <Flex mr={{ _: 0, tablet: '4x' }}>
      <Box mr="0,5x">{DateUtil.calendarDate(startTime)}</Box>
      <LiveDate
        date={startTime}
        format="cb_hmma"
        hasTitle
        timezone={getTimezone()}
      />
    </Flex>
  )
}

const StudentDetails = ({ avatarUrl, login }) => {
  return (
    <Flex justifyContent="center">
      <Box width="27px" mr="1x">
        <Image borderRadius="100%" src={avatarUrl} alt="" />
      </Box>
      <Box as="p" variant="text.paragraph">
        {login}
      </Box>
    </Flex>
  )
}

const UpcomingTutoringAppointment = ({
  startTime,
  unit,
  student,
  language: { code: lessonLanguageCode },
}) => {
  return (
    <Flex
      flexDirection={{ _: 'column', tablet: 'row' }}
      justifyContent="space-between"
      p="3x"
      boxShadow="overlay"
      borderRadius="1x"
    >
      {/* left-aligned part (on large screens)*/}
      <Flex flexDirection={{ _: 'column', tablet: 'row' }} alignItems="center">
        <UpcomingLessonIcon
          iconUrl={unit?.iconUrl}
          lessonLanguageCode={lessonLanguageCode}
        />
        {/* Lesson Details */}
        <Flex
          ml={{ _: 0, tablet: '2x' }}
          flexDirection="column"
          alignItems={{ _: 'center', tablet: 'stretch' }}
        >
          <Box as="h4" variant="text.h4" mb="1x">
            {t('Upcoming tutor lesson')}
          </Box>
          <Flex flexDirection={{ _: 'column', tablet: 'row' }}>
            <TimeDetails startTime={startTime} />
            <StudentDetails
              avatarUrl={student?.avatarUrl}
              login={student?.login}
            />
          </Flex>
        </Flex>
      </Flex>
      {/* right-aligned part (on large screens)*/}
      <Box
        alignSelf={{ _: 'auto', tablet: 'flex-end' }}
        mt={{ _: '2x', tablet: 0 }}
        width={{ _: '100%', tablet: 'auto' }}
      >
        <Button type="primaryAdvanced" href={routes.home_tutor()} width="100%">
          {t('Go to tutor dashboard')}
        </Button>
      </Box>
    </Flex>
  )
}

UpcomingTutoringAppointment.propTypes = {
  language: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  startTime: PropTypes.string.isRequired,
  student: PropTypes.object.isRequired,
  unit: PropTypes.object,
}

export default UpcomingTutoringAppointment
